import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'

// Import themes modules
import { px2Rem } from '../../themes/Mixins'
import ICON from '../../themes/Icon'

// Defined component Icon
const Icon = ({ icon, customStyle, src, ...props }) => {
  return (
    <img
      {...props}
      className={props.className}
      style={customStyle}
      src={src || ICON[icon]}
      alt={icon}
    />
  )
}

// Defined styled component for Icon
export default styled(Icon)`
  ${props => props.type === 'ideate' && css`
    width: ${props => px2Rem(props.width || '47')};
    height: ${props => px2Rem(props.height || '47')};
  `};

  ${props => props.type === 'design' && css`
    width: ${props => px2Rem(props.width || '54')};
    height: ${props => px2Rem(props.height || '54')};
  `};

  ${props => props.type === 'build' && css`
    width: ${props => px2Rem(props.width || '63')};
    height: ${props => px2Rem(props.height || '59')};
  `};

  ${props => props.type === 'engineers' && css`
    width: ${props => px2Rem(props.width || '74')};
    height: ${props => px2Rem(props.height || '86')};
  `};

  ${props => props.type === 'designer' && css`
    width: ${props => px2Rem(props.width || '48')};
    height: ${props => px2Rem(props.height || '85')};
  `};

  ${props => props.type === 'game' && css`
    width: ${props => px2Rem(props.width || '74')};
    height: ${props => px2Rem(props.height || '51')};
  `};

  ${props => props.type === 'language' && css`
    width: ${props => px2Rem(props.width || '64')};
    height: ${props => px2Rem(props.height || '30')};
  `};

  ${props => props.type === 'download' && css`
    width: ${props => px2Rem(props.width || '60')};
    height: ${props => px2Rem(props.height || '61')};
  `};
`

// Defined Props Types
Icon.propTypes = {
  icon: PropTypes.string,
  className: PropTypes.string
}

// Defined default Props
Icon.defaultProps = {
  icon: '',
  className: ''
}



// WEBPACK FOOTER //
// ./src/components/common/Icon.js